import { useQuery } from "react-query"
import { fetchCompareInvoice } from "./api"

// eslint-disable-next-line import/prefer-default-export
export const useCompareInvoice = params => {
  return useQuery(["fetchCompareInvoice", params], fetchCompareInvoice)
}
